import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

/* ModalRoute */

export class ModalRoute extends Component {
  render() {
    const { path, currentPath, component } = this.props;
    const TheComponent = component;

    if (path === currentPath && TheComponent) {
      return <TheComponent />;
    }

    return <div />;
  }
}

// Connect state data
function mapStateToProps(state) {
  const { path } = state.modal;
  return {
    currentPath: path,
  };
}

// Connect actions
export default connect(mapStateToProps, {})(ModalRoute);
